import React from "react";

interface EditableCellProps {
    cellData: any;
    onFactTableUpdate: (event: React.ChangeEvent<HTMLInputElement>) => void;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;
    rowNumber: Number;
}

const EditableCell = ({ cellData, onFactTableUpdate, blurField, focusField, rowNumber }: EditableCellProps) => (
    <td>
        <input
            type="text"
            name={cellData.type}
            id={cellData.id}
            value={cellData.value}
            onChange={onFactTableUpdate}
            onBlur={blurField}
            onFocus={() => {
                focusField("fact", rowNumber)
            }}
        />
    </td>
);

export default EditableCell;